import axios from "axios";
import config from "./config";
import { disconnectGlobalSocket } from "./services/socket";

const BASE_URL = config.baseApi;

const customAxios = axios.create({
  baseURL: BASE_URL,
});

const requestHandler = (request) => {
  const user = localStorage.getItem("linko_web");

  if (user) {
    const token = user;
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
};

const forceLogout = () => {
  try { indexedDB.deleteDatabase("linko_transcribe_db"); } catch (_e) { }
  disconnectGlobalSocket();
  localStorage.clear();
  window.location.href = "/login?reason=session_expired";
};

const responseHandler = (response) => {
  if (response.status === 401 || response.status === 403) {
    forceLogout();
  }
  return response;
};

const requestErrorHandler = (error) => {
  return Promise.reject(error);
};

const responseErrorHandler = (error) => {
  if (error.response) {
    const status = error.response.status;
    const message = error.response.data?.message || "";
    if (
      status === 401 ||
      status === 403 ||
      (status === 400 && message.toLowerCase().includes("invalid token"))
    ) {
      forceLogout();
      return Promise.reject(error);
    }
  }
  return Promise.reject(error);
};

customAxios.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => requestErrorHandler(error)
);

customAxios.interceptors.response.use(
  (response) => responseHandler(response),
  responseErrorHandler
);

export default customAxios;
